import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { AuthProvider } from './lib/auth';
import { ToastProvider } from './components/Toast';
import { ApiError, purgeImageCacheIfSignedOut } from './lib/api';
import { initTheme } from './lib/theme';
import './index.css';

// Before the first paint, so a reader who chose light does not get a frame of dark first.
initTheme();
purgeImageCacheIfSignedOut();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Clinical data: never show a stale figure without at least trying to refresh it, but do not
      // hammer the API while a reviewer works through a queue.
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // A 401/403/404 will not become truer on retry; only transient failures are worth repeating.
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
